__turbopack_context__.v({
  "h2": "KfP3Eq_h2",
  "p": "KfP3Eq_p",
  "sectionPadding": "KfP3Eq_sectionPadding",
});
